import { ReducerEntityPrefixTypes, ReducerNamespaceTypes } from "enums";
import { type FiltersEnum } from "features/Accounts/AllAccountsOverview/types";
import { type FiltersState, createFiltersSlice } from "features/Application/slices/createFiltersSlice";
import { type GenericFiltersMap } from "utils/filterUtils";

export interface GroupMembersAssignmentFiltersState extends FiltersState<FiltersEnum> {
  search: string;
}

export const initialState: GroupMembersAssignmentFiltersState = {
  filterOptions: {} as GenericFiltersMap<FiltersEnum>,
  appliedFilter: {} as GenericFiltersMap<FiltersEnum>,
  isLoading: false,
  search: "",
};

const groupMembersAssignmentFiltersSlice = createFiltersSlice({
  namePayload: {
    namespace: ReducerNamespaceTypes.People,
    entity: ReducerEntityPrefixTypes.AddGroup,
    name: "filters",
  },
  initialState,
  reducers: {},
});

export const { setSearch, resetFilter } = groupMembersAssignmentFiltersSlice.actions;

export default groupMembersAssignmentFiltersSlice.reducer;
